<div class="scratch-pad__container">
	<div class="scratch-pad__container__heading">
		<flx-heading color="scratch" size="small" margin="0">Scratch Pad</flx-heading>
		<flx-icon [type]="'remove'" color="scratch" active="primary" use="default" hover="primary" size="small" (click)="closeScratchPad()"></flx-icon>
	</div>
	<div class="scratch-pad__note__area">
		<form [formGroup]="scratchFormGroup"><textarea formControlName="notes" id="scratch-pad" rows="10"></textarea></form>
	</div>
</div>
